<template>
  <div class="learning_list">
    <search-com @search-btn="searchBtn"></search-com>
    <div class="nav_box">
      <welfare-breadcrumb :itemBreadcrumb="itemBreadcrumb"></welfare-breadcrumb>
    </div>
    <div class="learninglist_box">
      <div class="search_box">
        <div class="search_item">
          <span class="search_text">课程类别</span>:
          <div class="list_box">
            <span
              :class="
                searchForm.CategoryId == categoryItem.categoryId
                  ? 'list_item active_item'
                  : 'list_item'
              "
              v-for="categoryItem in categoryList"
              :key="categoryItem.categoryId"
              @click="searchCategory(categoryItem)"
              >{{ categoryItem.categoryName }}</span
            >
          </div>
        </div>
        <div class="search_item">
          <span class="search_text">细分类目</span>:
          <div class="list_box">
            <span
              :class="
                searchForm.SubCategoryId == subCategoryItem.categoryId
                  ? 'list_item active_item'
                  : 'list_item'
              "
              v-for="subCategoryItem in subCategoryList"
              :key="subCategoryItem.categoryId"
              @click="searchSubCategory(subCategoryItem)"
              >{{ subCategoryItem.categoryName }}</span
            >
          </div>
        </div>
        <div class="search_item">
          <span class="search_text">课程类型</span>:
          <div class="list_box">
            <span
              :class="
                searchForm.CourseType === courseTypeItem.id
                  ? 'list_item active_item'
                  : 'list_item'
              "
              v-for="(courseTypeItem, index) in courseTypeList"
              :key="index"
              @click="searchType(courseTypeItem)"
            >
              {{ courseTypeItem.name }}
            </span>
          </div>
        </div>
        <div class="search_item">
          <span class="search_text">收费</span>:
          <div class="list_box">
            <span
              :class="
                searchForm.FeeType === isFreeItem.status
                  ? 'list_item active_item'
                  : 'list_item'
              "
              v-for="(isFreeItem, index) in isFreeList"
              :key="index"
              @click="searchFree(isFreeItem)"
            >
              {{ isFreeItem.name }}
            </span>
          </div>
        </div>
      </div>
      <div class="learn_list_box" v-if="learnList && learnList.length">
        <div class="learn_list">
          <div
            class="learn_item"
            v-for="learnItem in learnList"
            :key="learnItem.id"
          >
            <img referrerpolicy="no-referrer" :src="learnItem.coverUrl" />
            <p class="learn_title">{{ learnItem.courseName }}</p>
            <div class="learn_other">
              <span class="learn_price">￥{{ learnItem.price }}</span>
              <el-button
                class="learn_btn"
                type="primary"
                @click="goDetaild(learnItem.id)"
                >查看详情</el-button
              >
            </div>
          </div>
        </div>
        <div class="meal_pagination" style="text-align:center;">
          <el-pagination
            @current-change="OnCurrentPageChanged"
            @size-change="handleSizeChange"
            :current-page="Params.PageIndex"
            :page-sizes="[20, 40, 60, 80, 100]"
            layout="prev, pager,next,sizes"
            :page-size="Params.Limit"
            background
            :total="Params.TotalCount"
          >
          </el-pagination>
        </div>
      </div>
      <div class="meal_list_none" v-else>
        <img src="~/assets/img/health/none.png" alt="缺省图" />
        <span>暂无内容</span>
      </div>
    </div>
  </div>
</template>
<script>
import SearchCom from "@/components/welfareMallComp/SearchCom";
import WelfareBreadcrumb from "@/components/welfareMallComp/WelfareBreadcrumb";
import { mapState, mapMutations } from "vuex";
import {
  getCourseList,
  getShopCategoryList,
  getShopSubCategoryList,
} from "@/network/courselearning";
export default {
  name: "learningList",
  components: {
    WelfareBreadcrumb,
    SearchCom,
  },
  data() {
    return {
      itemBreadcrumb: [
        {
          name: "企业商城",
          to: "/welfareHome",
        },
        {
          name: "课程商城",
          to: "/learningIndex",
        },
        {
          name: "课程列表",
        },
      ],
      searchForm: {
        CategoryId: 0,
        SubCategoryId: 0,
        CourseType: -1,
        FeeType: -1,
      },
      categoryList: [],
      subCategoryList: [],
      courseTypeList: [
        {
          id: -1,
          name: "全部",
        },
        {
          id: 0,
          name: "线上课程",
        },
        {
          id: 1,
          name: "直播课程",
        },
        {
          id: 2,
          name: "主题课程",
        },
      ],
      isFreeList: [
        {
          status: -1,
          name: "全部",
        },
        {
          status: 0,
          name: "免费",
        },
        {
          status: 1,
          name: "付费",
        },
      ],
      learnList: [],
      //分页
      Params: {
        PageIndex: 1,
        Limit: 20,
        TotalCount: 0,
      },
    };
  },
  computed: {
    // 映射
    ...mapState(["useInfo"]),
  },
  created() {
    let {categoryId,subCategoryId}=this.$route.params;
    if(categoryId&&subCategoryId){
      this.searchForm.CategoryId = categoryId;
      this.searchForm.SubCategoryId = subCategoryId;
      this.getSubCategory(categoryId)
    }else{
      this.getSubCategory();
    }
    this.getCategory();
    this.getLearnList();
  },
  methods: {
    // 点击查询 search
    searchBtn (val) {
      if(!val){
        return this.$message.info('请输入查询内容');
      }
      document.cookie = "vueRouter="+ '/welfareSearchResult';
      this.$router.push({
        name: 'WelfareSearchResult',
        params: {
          value: val
        }
      })
    },
    // 课程分类
    async getCategory() {
      let res = await getShopCategoryList();
      if (res.isSuccess) {
        this.categoryList = res.data;
        this.categoryList.unshift({ categoryId: 0, categoryName: "全部" });
      }
    },
    // 细分类目
    async getSubCategory(parentId) {
      let params = { parentId };
      let res = await getShopSubCategoryList(params);
      if (res.isSuccess) {
        this.subCategoryList = res.data;
        this.subCategoryList.unshift({ categoryId:0, categoryName: "全部" });
      }
    },
    // 查询数据列表
    async getLearnList() {
      let params = { ...this.searchForm, ...this.Params };
      let res = await getCourseList(params);
      if (res.isSuccess) {
        this.learnList = res.data;
        this.Params.TotalCount = res.count;
      }
    },
    // 选择课程分类
    searchCategory(item) {
      this.searchForm.CategoryId = item.categoryId;
      this.searchForm.SubCategoryId=0;
      let category = item.categoryId?item.categoryId:'';
      this.getSubCategory(category);
      this.getLearnList();
    },
    // 选择细分类目
    searchSubCategory(item) {
      this.searchForm.SubCategoryId = item.categoryId;
      this.getLearnList();
    },
    // 选择课程类型
    searchType(item) {
      this.searchForm.CourseType = item.id;
      this.getLearnList();
    },
    // 选择是否免费
    searchFree(item) {
      this.searchForm.FeeType = item.status;
      this.getLearnList();
    },
    // 跳转详情页
    goDetaild(courseId) {
      this.$router.push({
        name: "learningDetails",
        query: { courseId: courseId },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.learning_list {
  .learninglist_box {
    margin: 0 auto;
    width: 1200px;
    .search_box {
      margin-top: 30px;
      .search_item {
        display: flex;
        margin-bottom: 20px;
        .search_text {
          display: inline-block;
          width: 56px;
          font-weight: normal;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          text-align: justify;
          text-align-last: justify;
        }
        .list_box {
          margin-left: 10px;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .list_item {
            cursor: pointer;
            margin-right: 40px;
            margin-bottom: 10px;
            max-width: 105px;
            display: inline-block;
            font-size: 14px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:nth-child(1) {
              margin-left: 0;
            }
          }
          .active_item {
            padding: 0 10px;
            font-size: 14px;
            color: #4c80fa;
            border: 1px solid #4c80fa;
            border-radius: 5px;
          }
        }
      }
    }
    .learn_list_box {
      margin: 45px 0;
      .learn_list {
        margin-bottom: 20px;
        .learn_item {
          margin-left: 20px;
          margin-bottom: 20px;
          display: inline-block;
          width: 285px;
          height: 355px;
          border-radius: 10px;
          border: 1px solid #eef0f5;
          &:nth-child(4n + 1) {
            margin-left: 0;
          }
          img {
            display: block;
            width: 285px;
            height: 215px;
            background-size: 100% 100%;
            border-radius: 10px 10px 0 0;
          }
          .learn_title {
            margin: 20px 16px;
            height: 45px;
            font-size: 16px;
            font-weight: 400;
            color: #000327;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .learn_other {
            margin: 0 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .learn_price {
              font-size: 20px;
              font-weight: 400;
              color: #fe6262;
            }
            .learn_btn {
              width: 95px;
              height: 32px;
              line-height: 32px;
              padding: 0;
              font-size: 14px;
              color: #fff;
              border-radius: 15px;
            }
          }
        }
      }
    }
    .meal_list_none{
      display: flex;
      flex-direction:column;
      align-items:center;
      margin-bottom: 60px;
      img{
        width: 300px;
        height: auto;
        background: 100% 100%;
      }
      span{
        font-size: 16px;
        color: #3c3c3c;
      }
    }
  }
}
</style>
